// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eb928d03","453":"e10471bd","455":"21a56854","977":"53a8f87d"}[chunkId] + ".chunk.js";
};